export const TRANSIT_OPERATION_INFO_KEY = 'transit-operation-info'

export const transitOperationInfoQueryKeys = {
  all: [TRANSIT_OPERATION_INFO_KEY] as const,
  details: () => [...transitOperationInfoQueryKeys.all, 'detail'] as const,
  detail: (transitOperationId: number | null | undefined) => [
    ...transitOperationInfoQueryKeys.details(), transitOperationId,
  ] as const,
}
